import { onMounted, onUnmounted, ref } from 'vue'
import { fetchSupportUnreadCount } from '@/utils/supportApi'

const unreadCount = ref(0)
let pollTimer = null
let subscribers = 0

async function refresh() {
    try {
        const token = localStorage.getItem('token')
        if (!token) {
            unreadCount.value = 0
            return
        }
        const prev = unreadCount.value
        const data = await fetchSupportUnreadCount()
        const next = Number(data?.count ?? 0)
        if (next > prev && prev >= 0 && typeof window !== 'undefined' && 'Notification' in window) {
            if (Notification.permission === 'granted') {
                new Notification('Новый ответ поддержки', {
                    body: 'У вас есть непрочитанные сообщения в обращениях',
                    icon: '/favicon.ico',
                })
            }
        }
        unreadCount.value = next
    } catch {
        unreadCount.value = 0
    }
}

function startPolling() {
    if (pollTimer) return
    refresh()
    pollTimer = setInterval(refresh, 30000)
}

function stopPolling() {
    if (pollTimer) {
        clearInterval(pollTimer)
        pollTimer = null
    }
}

export function useSupportUnread() {
    onMounted(() => {
        subscribers += 1
        startPolling()
        if (typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'default') {
            Notification.requestPermission().catch(() => {})
        }
    })

    onUnmounted(() => {
        subscribers -= 1
        if (subscribers <= 0) {
            subscribers = 0
            stopPolling()
        }
    })

    return {
        unreadCount,
        refreshUnread: refresh,
    }
}
